import styled from "styled-components";

export const SecondaryButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  border: 1px solid ${({theme}) => theme.accent};
  padding: 15px 24px;
  background: transparent;
  border-radius: 31px;
  outline: none;

  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.2px;
  color: ${({theme}) => theme.accent};

  transition: all 300ms ease;
  
  > svg {
    margin-left: 20px;
    fill: ${({theme}) => theme.accentLight};
  }

  :hover {
    cursor: pointer;
    color: ${({theme}) => theme.accentLight};
    border-color: ${({theme}) => theme.accentLight};
  }

  :disabled {
    opacity: 0.5;
  }

  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    width: 100%;
  }
`
